import 'css-chunk:src/app/containers/Html/Html.scss';export default {
  "html": "_html_bexs5_1",
  "body": "_body_bexs5_27",
  "content": "_content_bexs5_32"
};